/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import {alert} from 'util/alert'
import {confirm} from 'util/confirm'
import locale from './locale'
import getPosterOrderPay from 'controllers/payment/getPosterOrderPay'
import './Modal.scss';


class ModalContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
    }
  }

  render() {
    const {dismiss, order_number, onHeightChange, proceed} = this.props
    const {step} = this.state

    if(step == 1){
      return (
        <div className='ali-poster-payment-modal-content text-center'>
          <div className='ali-pay-title'>{__('Please complete the payment in Alipay and confirm the payment', locale)}</div>
          <button className='btn btn-default' onClick={() => {dismiss()}}>{__('Cancel', locale)}</button>
          <button className='btn btn-primary' onClick={() => {
            getPosterOrderPay(order_number)
            .then((res) => {
              if(res.payment_result == 'success'){
                this.setState({step: 2}, onHeightChange(400))
              } else {
                alert.warning(__('Payment unsuccessful, please try again', locale))
              }
            })
          }}>{__('Success', locale)}</button>
        </div>
      )
    } else if(step == 2){
      return(
        <div className='ali-poster-success-modal-content text-center'>
          <img src={require('./images/Group@2x.png')} />
          <p>{__('Payment Successful', locale)}</p>
          <button className='btn btn-primary btn-block' onClick={() => {
            proceed({paySuccessful: true})
            dismiss()
          }}>{__('Complete', locale)}</button>
        </div>
      )
    }
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/aliPosterPayment/ModalContent.js